import { render, staticRenderFns } from "./NotificationGuide.vue?vue&type=template&id=546849d8"
import script from "./NotificationGuide.vue?vue&type=script&lang=js"
export * from "./NotificationGuide.vue?vue&type=script&lang=js"
import style0 from "./NotificationGuide.vue?vue&type=style&index=0&id=546849d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports